import styled from 'styled-components'

export const Container = styled.div`
  color: ${({theme}) => theme.colors.textPrimary};
  background: ${({theme}) => theme.colors.bgPaper};
  border-radius: ${({theme}) => theme.sizes.radii.default};
  border: 1px solid ${({theme}) => theme.colors.border};
  box-shadow: ${({theme}) => theme.colors.shadowBox};
  padding: 0 25px;
  flex: 1;
  overflow: hidden;
  min-width: 0;

  ${({theme}) => theme.breakpoints.down('tablet')} {
    padding: 0 15px;
  }
`

export const Header = styled.div`
  min-height: 70px;
  border-bottom: 1px solid ${({theme}) => theme.colors.border};
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${({theme}) => theme.breakpoints.down('tablet')} {
    min-height: 60px;
  }
`

export const HeaderText = styled.h2`
  display: flex;
  font-weight: 500;
  font-size: ${({theme}) => theme.fontSizes.titleSmall};
  font-family: ${({theme}) => theme.fontFamilies.default};
  margin: 0;
  ${({theme}) => theme.breakpoints.down('mobileM')} {
    font-size: ${({theme}) => theme.fontSizes.medium};
  }
`

export const HeaderAction = styled.button`
  appearance: none;
  background: none;
  border: 0;
  padding: 0;
  cursor: pointer;
  font-size: ${({theme}) => theme.fontSizes.default};
  text-transform: uppercase;
  text-decoration: underline;
  color: ${({theme}) => theme.colors.textSecondary};

  ${({theme}) => theme.breakpoints.down('mobileM')} {
    font-size: ${({theme}) => theme.fontSizes.small};
  }
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 0;
`
